import config from '../../assets/config';

export const isValidUrl = (url) => (url.startsWith('http://') || url.startsWith('https://')) && !!url.match(config.regexValid.url);
